import { useState } from 'react';

import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import { ACCOUNT_USER_DETAIL_ORDER_HISTORY_LIST_FILTER_OPTION_MODEL } from './models';
import { getTablePages } from '../../../../../lib/utils/tableUtils';
import { useAccountUserDetailOrderListQuery, useAccountUserOrderDetailQuery } from './query';

export const useAccountUserOrderDetail = ({ userId, isActive }) => {
  const { data } = useAccountUserOrderDetailQuery({
    userId,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_ORDER_DETAIL_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => result.data.orderSummaryData,
    },
  });

  return data;
};

export const useAccountUserDetailOrderList = ({ userId, isActive }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_ORDER_HISTORY_LIST_FILTER_OPTION_MODEL);

  const { data } = useAccountUserDetailOrderListQuery({
    userId,
    pagination,
    filterOption,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_ORDER_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        list: result.data.orderHistoryList.list,
        totalCnt: result.data.orderHistoryList.totalCnt,
      }),
    },
  });

  return {
    orderHistoryList: data,
    pagination: { ...pagination, pages: getTablePages(data.totalCnt, pagination.pageSize) },
    filterOption,
    setPagination,
    setFilterOption,
  };
};
